import './style.scss';

function Spinner() {
  return <span className="B-spinner" />;
}

export default Spinner;
